import { styled, Theme } from "@mui/material/styles";

import CreatePreJoinScreens from "./components/video/PreJoinScreens/CreatePreJoinScreens";
import MenuBar from "./components/video/MenuBar/MenuBar";
import MobileTopMenuBar from "./components/video/MobileTopMenuBar/MobileTopMenuBar";
import ReconnectingNotification from "./components/video/ReconnectingNotification/ReconnectingNotification";
import RecordingNotifications from "./components/video/RecordingNotifications/RecordingNotifications";
import Room from "./components/video/Room/Room";
import useHeight from "./hooks/useHeight/useHeight";
import useRoomState from "./hooks/useRoomState/useRoomState";
import { Redirect } from "react-router-dom";
import { useVideoState } from "./state";

const Container = styled("div")({
  display: "grid",
  gridTemplateRows: "1fr auto"
});

const Main = styled("main")(({ theme }: { theme: Theme }) => ({
  overflow: "hidden",
  paddingBottom: `${theme.footerHeight}px`,
  background: "black",
  [theme.breakpoints.down("md")]: {
    paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`
  }
}));

export default function CreateVideo() {
  const roomState = useRoomState();
  const { endRoom } = useVideoState();
  const height = useHeight();

  if (roomState === "disconnected" && endRoom) {
    return <Redirect to="/app/state/disconnected" />;
  }

  return (
    <Container style={{ height }}>
      {roomState === "disconnected" ? (
        <CreatePreJoinScreens />
      ) : (
        <Main>
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </Main>
      )}
    </Container>
  );
}
